module.exports = __webpack_public_path__ + "img/48_2.5509f38a.png";